import { select, call, put, cancelled } from 'redux-saga/effects';
import { getArticle, getRegionCode } from 'common/selectors';
import type { CallEffectReturnType } from 'types/utils';
import { api } from 'api';
import log from 'loglevel';
import { getHideServices } from 'features/page-model';
import { fetchRelatedServices } from './api';
import { FETCH_RELATED_SERVICES } from './actions';
import { RelatedServiceSuccessResponse } from '../types';

export function* doFetchRelatedServices() {
  const isHideServices = (yield select(getHideServices)) as ReturnType<typeof getHideServices>;
  const productId = (yield select(getArticle)) as ReturnType<typeof getArticle>;
  const regionCode = (yield select(getRegionCode)) as ReturnType<typeof getRegionCode>;

  const abortController = (yield call([api, 'abortController'])) as ReturnType<
    (typeof api)['abortController']
  >;
  if (!isHideServices?.on) {
    try {
      const data = (yield call(
        fetchRelatedServices,
        { productId, regionCode },
        { cancelToken: abortController.token },
      )) as CallEffectReturnType<typeof fetchRelatedServices>;

      yield put(FETCH_RELATED_SERVICES.success(data as RelatedServiceSuccessResponse));
    } catch (e) {
      let actionError;
      if (e instanceof Error) {
        actionError = e;
      } else {
        actionError = new Error(JSON.stringify(e));
      }
      yield put(FETCH_RELATED_SERVICES.failure(actionError));
    } finally {
      if ((yield cancelled()) as boolean) {
        abortController.cancel();
        yield call([log, 'info'], '"doFetchRelatedServices" was cancelled');
        yield put(FETCH_RELATED_SERVICES.cancel());
      }
    }
  } else {
    yield put(
      FETCH_RELATED_SERVICES.success({
        relatedServices: [],
        baseEntityIds: [],
      }),
    );
  }
}
